module.exports = __webpack_public_path__ + "static/media/BASIS-WATERNIVEAU_03.eaa879f5.apng";